import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastType } from '../enums/toast.enum';
import { Toast } from '../models/toast.model';
import { Subject } from 'rxjs';
import { ApiError } from '../models/api-error.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private messageLife = 3000;
  private toastQueue = new Subject<Toast>();
  private apiErrorQueue = new Subject<ApiError>();
  toast$ = this.toastQueue.asObservable();
  apiError$ = this.apiErrorQueue.asObservable();

  // Kolejka dla wiadomości które mają być dodane później
  private messageQueue: Toast[] = [];

  // Wyświetlenie od razu
  showMessage(type: ToastType, header: string, body: string, life = this.messageLife) {
    const msg: Toast = {
      key: 'toast',
      severity: type,
      summary: header,
      detail: body,
      life
    };
    this.toastQueue.next(msg);
  }

  // Dodanie wiadomości do kolejki
  addMessage(type: ToastType, summary: string, detail: string, life = this.messageLife) {
    const msg: Toast = {
      key: 'toast',
      severity: type,
      summary,
      detail,
      life
    };
    this.messageQueue.push(msg);
  }

  // Wysłanie wszystkich wiadomości z kolejki
  flushMessages() {
    while (this.messageQueue.length > 0) {
      const msg = this.messageQueue.shift()!;
      this.toastQueue.next(msg);
    }
  }

  reportApiError(error: ApiError): void {
    this.apiErrorQueue.next(error);
  }
}
